module.exports = __webpack_public_path__ + "static/media/ios-desktop.0f431552.svg";